import { useState, useMemo } from "react";

export default function AssignedProjectsPicker({
  allProjects,
  selectedIds,
  onToggle,
  onClear,
}) {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredProjects = useMemo(() => {
    if (!searchQuery.trim()) return allProjects;
    const q = searchQuery.toLowerCase();
    return allProjects.filter(
      (p) =>
        p.projectName?.toLowerCase().includes(q) ||
        p.projectNumber?.toString().toLowerCase().includes(q),
    );
  }, [allProjects, searchQuery]);

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <p className="text-xs text-gray-500">
          {selectedIds.length === 0
            ? "No restriction — sees all active projects."
            : `Restricted to ${selectedIds.length} project${selectedIds.length !== 1 ? "s" : ""}.`}
        </p>
        {selectedIds.length > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs text-orange-400 hover:text-orange-300 transition-colors"
          >
            Clear
          </button>
        )}
      </div>

      <input
        type="text"
        placeholder="Search projects…"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="w-full mb-2 px-3 py-2 text-sm bg-gray-700 border border-gray-600 rounded-lg
                   text-gray-200 placeholder-gray-500 focus:outline-none focus:ring-1
                   focus:ring-orange-400 focus:border-orange-400 transition-colors"
      />

      <div className="max-h-56 overflow-y-auto space-y-1 pr-1">
        {filteredProjects.length === 0 ? (
          <p className="text-xs text-gray-600 text-center py-4">
            No projects match
          </p>
        ) : (
          filteredProjects.map((project) => {
            const isChecked = selectedIds.includes(project._id);
            return (
              <label
                key={project._id}
                className={`flex items-center gap-2.5 px-3 py-2 rounded-lg cursor-pointer transition-colors border ${
                  isChecked
                    ? "bg-orange-400/10 border-orange-400/30"
                    : "bg-gray-700/30 border-transparent hover:bg-gray-700"
                }`}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={() => onToggle(project._id)}
                  className="w-4 h-4 text-orange-400 bg-gray-800 border-gray-600 rounded accent-orange-400 shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-gray-200 truncate">
                    {project.projectName}
                  </p>
                  {project.projectNumber && (
                    <p className="text-xs text-gray-500 font-mono">
                      #{project.projectNumber}
                    </p>
                  )}
                </div>
              </label>
            );
          })
        )}
      </div>
    </div>
  );
}
